import { useEffect, useState } from 'react';
import { IntegrationAppProvider } from '@membranehq/react';
import { ListAccountConnections } from './ListAccountConnections';
import useAuthedRequest from 'src/hooks/useAuthedRequest';

export const ListAccountConnectionsProvider = () => {
  const { get } = useAuthedRequest();
  const [token, setToken] = useState('');

  const getIntegrationAppToken = async () => {
    const response = await get('/account-connections/integration-app/token');

    if (response.token) setToken(response.token);
  };

  useEffect(() => {
    getIntegrationAppToken();
  }, []);

  return (
    <IntegrationAppProvider token={token}>
      <ListAccountConnections />
    </IntegrationAppProvider>
  );
};
